export default "__VITE_ASSET__Dbpks1D4__"